import { Navigate, Outlet, useLocation } from 'react-router';
import { Button } from '../../../shared/components/button';
import { StateMessage } from '../../../shared/components/state-message';
import { TallyLoader } from '../../../shared/components/tally-loader';
import { ROUTES } from '../../../shared/constants/app.constant';
import { useSession } from '../hooks/use-session';

export function RequireAuth() {
  const location = useLocation();
  const { user, isLoading, isUnauthenticated, error, retry } = useSession();

  if (isLoading) return <TallyLoader label="Memeriksa sesi" className="p-8" />;
  if (isUnauthenticated) return <Navigate to={ROUTES.login} replace state={{ from: location.pathname }} />;
  if (error || !user) {
    return (
      <div className="mx-auto max-w-md p-8">
        <StateMessage
          tone="error"
          title="Server belum bisa dihubungi"
          description={error?.message ?? 'Coba muat ulang sebentar lagi.'}
          action={<Button onClick={retry}>Coba lagi</Button>}
        />
      </div>
    );
  }
  return <Outlet />;
}
